import { getConfigData } from "../../../helpers/getConfigData";
import axios from 'axios';

const getResponseWithOpenAI = async ({ prompt }) => {

    const configData = await getConfigData({ name: ['openAiKey', 'openAiBaseUrl'] })
    const { openAiKey, openAiBaseUrl } = configData
    try {

        const response = await axios.post(
            openAiBaseUrl,
            {
                model: "gpt-4.1-nano",
                messages: [{ role: "user", content: prompt }],
                temperature: 0.4,
                top_p: 0.9,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${openAiKey}`,
                },
            }
        );

        const content = response?.data?.choices[0]?.message?.content;

        return {
            status: 200,
            content
        };
    } catch (error) {
        console.error("OpenAI API Error:", error?.response?.data || error.message);
        return {
            status: 500,
            error: error?.response?.data || error.message
        }
    }
};

export default getResponseWithOpenAI;
